(() => {
  if (window.__minimogCartLiveSyncLoaded) return;
  window.__minimogCartLiveSyncLoaded = true;

  const CART_MUTATION_RE = /\/cart\/(?:add|change|update|clear)\.js(?:[?#].*)?$/i;
  const COUNT_SELECTORS = '.m-cart-count, .m-cart-count-bubble, .cart-count, [data-cart-count]';
  let syncTimer = null;
  let shouldReopenDrawer = false;
  let syncInFlight = null;
  let pendingSyncAfterCurrent = false;

  function getRequestUrl(input) {
    try {
      if (input instanceof Request) return new URL(input.url, window.location.origin);
      return new URL(String(input), window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function updateCartCount(itemCount) {
    document.querySelectorAll(COUNT_SELECTORS).forEach((element) => {
      element.textContent = itemCount;

      if (element.hasAttribute('data-cart-count')) {
        element.setAttribute('data-cart-count', itemCount);
      }

      if (itemCount > 0) {
        element.classList.remove('m:hidden');
      } else {
        element.classList.add('m:hidden');
      }
    });

    document.querySelectorAll('.m-cart-icon-bubble').forEach((element) => {
      element.setAttribute('aria-label', String(itemCount));
    });
  }

  async function fetchFreshCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js?t=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch fresh cart state.');
    }

    return response.json();
  }

  async function refreshCartDrawer(openDrawer) {
    const currentDrawer = document.querySelector('m-cart-drawer');
    if (!currentDrawer) return;

    const drawerWasOpen =
      openDrawer ||
      currentDrawer.classList.contains('m-cart-drawer--active') ||
      currentDrawer.classList.contains('active') ||
      currentDrawer.classList.contains('is-open');

    const response = await fetch(`${window.location.origin}/?section_id=cart-drawer&t=${Date.now()}`, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) return;

    const html = await response.text();
    const parser = new DOMParser();
    const documentFromResponse = parser.parseFromString(html, 'text/html');
    const nextDrawer = documentFromResponse.querySelector('m-cart-drawer');

    if (!nextDrawer) return;

    currentDrawer.outerHTML = nextDrawer.outerHTML;

    if (!drawerWasOpen || !window.MinimogSettings?.enable_cart_drawer) return;

    requestAnimationFrame(() => {
      const refreshedDrawer = document.querySelector('m-cart-drawer');
      if (refreshedDrawer && typeof refreshedDrawer.open === 'function') {
        refreshedDrawer.open(document.querySelector('.m-cart-icon-bubble') || undefined);
      }
    });
  }

  async function refreshCartPage() {
    const currentSection = document.querySelector('#shopify-section-cart-template');
    if (!currentSection || !window.MinimogSettings?.routes?.cart) return;

    const response = await fetch(
      `${window.MinimogSettings.routes.cart}?section_id=cart-template&t=${Date.now()}`,
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }
    );

    if (!response.ok) return;

    const html = await response.text();
    const parser = new DOMParser();
    const documentFromResponse = parser.parseFromString(html, 'text/html');
    const nextSection = documentFromResponse.querySelector('#shopify-section-cart-template');

    if (nextSection) {
      currentSection.innerHTML = nextSection.innerHTML;
    }
  }

  async function syncCartUi({ openDrawer = false } = {}) {
    if (syncInFlight) {
      pendingSyncAfterCurrent = pendingSyncAfterCurrent || openDrawer;
      return syncInFlight;
    }

    syncInFlight = (async () => {
      try {
        const cart = await fetchFreshCart();
        const itemCount = Number(cart.item_count) || 0;

        updateCartCount(itemCount);

        document.querySelectorAll('m-cart-drawer, m-cart-drawer-items, m-cart').forEach((element) => {
          element.classList.toggle('m-cart--empty', itemCount === 0);
        });

        await Promise.allSettled([refreshCartDrawer(openDrawer), refreshCartPage()]);
      } catch (error) {
        console.error('Cart live sync failed:', error);
      } finally {
        syncInFlight = null;

        if (pendingSyncAfterCurrent) {
          const reopenDrawer = pendingSyncAfterCurrent;
          pendingSyncAfterCurrent = false;
          syncCartUi({ openDrawer: reopenDrawer });
        }
      }
    })();

    return syncInFlight;
  }

  function scheduleSync({ openDrawer = false } = {}) {
    shouldReopenDrawer = shouldReopenDrawer || openDrawer;

    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => {
      const reopenDrawer = shouldReopenDrawer;
      shouldReopenDrawer = false;
      syncCartUi({ openDrawer: reopenDrawer });
    }, 80);
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = function wrappedFetch(input, init) {
    const requestUrl = getRequestUrl(input);
    const method = String((init && init.method) || (input instanceof Request && input.method) || 'GET').toUpperCase();
    const isCartMutation =
      method !== 'GET' &&
      requestUrl &&
      CART_MUTATION_RE.test(`${requestUrl.pathname}${requestUrl.search}`);
    const isCartAddRequest = isCartMutation && /\/cart\/add\.js$/i.test(requestUrl.pathname);

    return originalFetch(input, init).then((response) => {
      if (isCartMutation && response.ok) {
        scheduleSync({ openDrawer: isCartAddRequest });
      }

      return response;
    });
  };

  document.addEventListener('cart:refresh', () => scheduleSync());
  document.addEventListener('cart:updated', () => scheduleSync());
})();
